<template>
    <div class="post-listing-wrapper">
        <infinite-scroller-vertical @scrolledTillBottom="onReachScrollBottom">
            <v-container fluid>
                <v-row dense>
                    <v-col v-for="(post) in posts" :key="`profile-post-${post.id}`" cols="6" md="4">
                        <v-card tile flat :to="`/post/${post.id}/`" :color="post.attachments.length ? 'grey' : 'primary'">
                            <v-img v-if="post.attachments.length" 
                            :src="post.attachments[0].file_url" :lazy-src="post.attachments[0].thumbnail_file_url" :aspect-ratio="1">
                                <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                            <v-card-title v-else v-html="post.title" class="justify-center"></v-card-title>
                        </v-card>
                    </v-col>
                    <template dense v-if="postListLoading">
                        <v-col class="d-flex" v-for="(n, i) in 3" :key="`photo-skel-loading-${i}`" cols="6" md="4">
                            <v-skeleton-loader type="image" width="100%" class="d-flex" tile></v-skeleton-loader>
                        </v-col>
                    </template>
                </v-row>
            </v-container>
            <v-container fluid v-if="!postListLoading && posts.length===0">
              <v-col cols="12"><p class="headline font-weight-light text-center">No Post! 
                <router-link tag="span" class="textLinks--text" to="/create/post/" 
                v-if="user.id === $store.state.profile.activeProfile.id">Create</router-link></p></v-col>
            </v-container>
        </infinite-scroller-vertical>
    </div>
</template>
<script>
import {
    GET_PROFILE_POST_LIST
} from "@/store/actions.type"
export default {
    created() {
        if (this.posts.length === 0 && !this.postListLoading) {
            this.$store.dispatch(GET_PROFILE_POST_LIST, {
                profileId: this.$route.params.username,
                type: 'profilePost'
            })
        }
    },
    data: () => ({

    }),

    methods: {

        onReachScrollBottom(val) {
            if (val) {
                if (!this.$store.state.profile.profilePostFetchCompleted && !this.postListLoading) {
                    this.$store.dispatch(GET_PROFILE_POST_LIST, {
                        profileId: this.$route.params.username,
                        type: 'profilePost'
                    })
                }
            }
        }
    },

    destroyed() {},

    computed: {
        posts() {
            return this.$store.state.profile.profilePostList
        },

        postListLoading() {
            return this.$store.state.profile.profilePostListLoading
        }
    }


}
</script>